import { render, staticRenderFns } from "./change_image_component.vue?vue&type=template&id=37af575e&scoped=true"
import script from "./change_image_component.vue?vue&type=script&lang=js"
export * from "./change_image_component.vue?vue&type=script&lang=js"
import style0 from "./change_image_component.vue?vue&type=style&index=0&id=37af575e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af575e",
  null
  
)

export default component.exports